import React, { useEffect } from "react";
import ReactModal from "react-modal";
import { FormProvider, useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import CrossIcon from "../../../../assets/icons/cross.svg";
import { validationSchema } from "../debtLoadDateModalSchema";
import { useDispatch, useSelector } from "react-redux";
import PensionerSection from "../components/PensionerSection";
import IncomeSection from "../components/IncomeSection";
import PaymentSection from "../components/PaymentSection";
import { prepareFormData, transformFormData } from "../helper";
import { handleKeyPressTA } from "../../../../helpers/common";
import {
  fetchDebtLoadCalculate,
  getClientLastDebtLoadSuccess,
} from "../../../../redux/actions/debtLoadAction";
import { RADIO_NAMES, defaultDebtLoadFormValues } from "../constants/constants";
import "../debtLoadCalculation.scss";
import { HInput } from "../../../../validation/HForm";
import DebtLoadDataFormLoader from "./DebtLoadDataFormLoader";
import {couponType} from "../../../../helpers/data-constants";

const DebtLoadDataForm = ({
  isOpen,
  currentDealAmount,
  clientContract,
  onClose,
  currentDealDuration,
  typeCreateDeal
}) => {
  const dispatch = useDispatch();
  const { client } = useSelector(({ clientInfo }) => clientInfo);
  const { clientDebtLoadData, loading } = useSelector(({ debtLoad }) => debtLoad);

  const form = useForm({
    defaultValues: defaultDebtLoadFormValues,
    resolver: joiResolver(validationSchema),
  });

  const getCurrentDealDuration = () => {
    switch (typeCreateDeal) {
      case couponType.ANNUITY_HYBRID: {
        return currentDealDuration + 1;
      }
      case couponType.ANNUITY: {
        return currentDealDuration;
      }
      default: {
        return 1
      }
    }
  }

  const handleFormSubmit = (data) => {
    const newData = {
      ...data,
      currentDealDuration: getCurrentDealDuration()
    };
    const transformedData = transformFormData(newData);
    dispatch(fetchDebtLoadCalculate(client.id, transformedData));
    onClose();
  };

  useEffect(() => {
    if (isOpen && clientDebtLoadData) {
      const formData = prepareFormData(clientDebtLoadData);
      form.reset(formData);
    }
  }, [isOpen, clientDebtLoadData, form.reset]);

  useEffect(() => {
    return () => dispatch(getClientLastDebtLoadSuccess(null));
  }, []);

  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel="Modal"
      className="modal-container"
      overlayClassName="modal-overlay"
    >
       {loading ? (
        <DebtLoadDataFormLoader />
      ) : (
      <FormProvider {...form}>
        <form
          onSubmit={form.handleSubmit(handleFormSubmit)}
          onKeyPress={handleKeyPressTA}
        >
          <div className="modal-header">
            <h2>Анкета для расчета ПДН</h2>
            <button
              className="button-icontrigger modal-closetrigger"
              onClick={onClose}
            >
              <span className="icon">
                <CrossIcon />
              </span>
            </button>
          </div>
          <div className="modal-body modal-body__height debt-modal">
            <HInput type="hidden" name="clientId" defaultValue={client.id} />
            <HInput
              type="hidden"
              name="currentDealAmount"
              defaultValue={currentDealAmount}
            />
            <HInput
              type="hidden"
              name="previousDealId"
              defaultValue={clientContract?.dealId}
            />

            <PensionerSection questionNumber={1} />

            <PaymentSection
              questionNumber={2}
              title="Клиент трудоустроен (имеет постоянную трудовую занятость)?"
              radioName={RADIO_NAMES.IS_WORKING}
            />

            <IncomeSection
              questionNumber={3}
              title="Ежемесячный доход клиента"
            />

            <PaymentSection
              questionNumber={4}
              title="Ежемесячные платежи клиента"
              radioName={RADIO_NAMES.MONTHLY_PAYMENT}
            />
          </div>
          <div className="modal-footer flex-space-between">
            <button className="button" type="submit">
              Рассчитать
            </button>
            {Object.keys(form.formState.errors).length > 0 && (
              <span className="form-message error">
                *Пожалуйста, заполните все обязательные поля
              </span>
            )}
          </div>
        </form>
      </FormProvider>)}
    </ReactModal>
  );
};

export default DebtLoadDataForm;
